import { render } from "./NJLSLREX.vue?vue&type=template&id=f1647c54&scoped=true"
import script from "./NJLSLREX.vue?vue&type=script&lang=js"
export * from "./NJLSLREX.vue?vue&type=script&lang=js"

import "./NJLSLREX.vue?vue&type=style&index=0&id=f1647c54&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1647c54"]])

export default __exports__